import React, { Children } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import successImg from "./img/check-img.png";
import errorImg from "./img/close.png";
import "./styles/ResponseModal.scss";
import { FormattedMessage } from 'react-intl';

const ResponseModal = ({ isOpen, closeModal, modalType, goHome }) => {

  const handleToggleModal = () => {
    closeModal(modalType);
    goHome(modalType);
  }

  return (
    <Modal isOpen={isOpen} centered className='response-modal' size='lg'>
      <section className='p-2 p-lg-4'>
        <ModalHeader className='border-0 m-0 p-0' toggle={handleToggleModal} />
        <ModalBody className='m-0 py-lg-4'>
          {modalType === "success" ? (
            <section className='text-center response-modal__desc-content'>
              <img src={successImg} alt='check-image' className='mb-4' width={72} height={72} />
              <h6 className='font-weight-bold mb-2'>
                <FormattedMessage 
                  id='ProjectStepForm.step4.modal.success.title'
                  defaultMessage='¡Gracias por completar la información!'
                />
              </h6>
              <p className='p-0 m-0'>
                <FormattedMessage 
                  id='ProjectStepForm.step4.modal.success.desc'
                  defaultMessage='Tu proyecto inició la fase de aprobación y{br}
                  recibirás un correo cuando sea publicado.'
                  values={{
                    br: <br />
                  }}
                />
              </p>
            </section>
          ) : (
            <section className='text-center response-modal__desc-content'>
              <img src={errorImg} alt='error-image' className='mb-4' width={72} height={72} />
              <p className='p-0 m-0 response-modal__error-desc'>
                <FormattedMessage 
                  id='ProjectStepForm.step4.modal.error.desc'
                  defaultMessage='Lo sentimos, ha ocurrido un error en la plataforma. {br}
                  Por favor intenta cargar tu proyecto más tarde.'
                  values={{
                    br: <br />
                  }}
                />
              </p>
            </section>
          )}
        </ModalBody>
      </section>
    </Modal>
  )
}

export default ResponseModal